/**
 * Shared helpers for the iconik launch-credentials sessionStorage entry.
 *
 * Kept in a separate module (not in SelectOrganization.tsx) so that ApiService
 * can import clearLaunchCreds without creating a circular dependency:
 *
 *   ApiService.ts  ←  launchCreds.ts  (this file; no imports from ApiService)
 *   SelectOrganization.tsx  ←  launchCreds.ts  (re-exports the helpers)
 */

export const CREDS_KEY = "iconik_launch_creds";

/**
 * Remove saved launch creds from sessionStorage.
 * Call this whenever the manager session ends (signOut, 401 auth failure).
 */
export const clearLaunchCreds = (): void =>
  sessionStorage.removeItem(CREDS_KEY);
